export default __webpack_public_path__ + "static/media/de.02d6c00e.svg";